module.exports = __webpack_public_path__ + "img/p1@2x.420c921a.jpg";